import axios from 'axios';
import Vue from 'vue';
import { TrackingType } from '../../utils/CONSTANT';
import * as types from '../mutation-types';


const NO_TRACK = 'notrack'

const TRACKING_ROUTE_URL = '/v1/routes/temperaturemonitor/h5/';
const TRACKING_TRANSPORT_URL = '/v1/transportorders/temperaturemonitor/h5/';
const TRACKING_TRANSPORT_LIST = (id) => `/v1/routes/temperaturemonitor/h5/list/${id}/TRANSPORT`
const TRACKING_ROUTE_LIST = (id) => `/v1/routes/temperaturemonitor/h5/list/${id}/ROUTE`;
const TRACKING_ORDER_LIST = (id) => `/v1/routes/temperaturemonitor/h5/list/${id}/ORDER`

const state = {
    trackingMode: TrackingType.Transport,
    trackVehicle: [],
    trackTransport: [],
    mapData: {}
};

const getters = {

    trackingVehicle: state => state.trackVehicle.length > 0 ? state.trackVehicle[0] : null,

    isHaveMapData: state => {
        const mapData = state.mapData;
        // The logic from Chinese team is if carIndex does not exist, we will assign it to 0
        // But I cannot find any logic that provide carIndex, so we assign it to 0
        const carIndex = 0;
        return !(!mapData.capacityTracks || mapData.capacityTracks.length == 0 || !mapData.capacityTracks[carIndex].gpsTracks || mapData.capacityTracks[carIndex].gpsTracks.length <= 0);
    },

    gpsTrackData: (state, getters) => {
        const isHaveMapData = getters.isHaveMapData;

        if (!isHaveMapData) {
            return [];
        }

        const mapData = state.mapData;

        const gpsTracks = mapData.capacityTracks[0].gpsTracks;
        return gpsTracks.filter(track => track.lng && track.lat);
    },

    mapData: state => state.mapData,

};

const actions = {

    getListRoutes({ commit }, {pid: id, trackingMode}) {
        return new Promise((resolve, reject) => {
            let url = null;

            console.log(trackingMode)

            if(Number(trackingMode) === TrackingType.Transport) {
                url =TRACKING_TRANSPORT_LIST(id)
            }else if(Number(trackingMode) === TrackingType.Route) {
                url = TRACKING_ROUTE_LIST(id)
            }else {
                url = TRACKING_ORDER_LIST(id)
            }

            axios.get(url).then((response) => {

                const items = response.data.items;

                const trackingVehicle = (items.vehicles ? items.vehicles : []).filter(x => x.track !== NO_TRACK);
                const trackingTransport = (items.transports ? items.transports : []);

                commit(types.SET_PARAM, ['trackVehicle', trackingVehicle]);
                commit(types.SET_PARAM, ['trackTransport', trackingTransport]);
                resolve(response.data);
            }).catch((err) => {
                reject(err);
            }).finally(() => {
                // console.log('finally');
            });
        });
    },

    getTrackingData({ commit, state }, { trackingMode, routeId, transportId, plateNo, equipmentNo, platformName }) {
        return new Promise(async (resolve, reject) => {

            console.log(trackingMode)

            const url = trackingMode === TrackingType.Transport ? TRACKING_TRANSPORT_URL : TRACKING_ROUTE_URL;
            const id = trackingMode === TrackingType.Transport ? transportId : routeId;


            try {
                const response = await axios.get(url + id, {
                    params: {
                        plateNo: plateNo, // '京KEC897',
                        equipmentNo: equipmentNo,
                        platformName: platformName
                    }
                });

                const items = response.data.items;
                console.log(items)
                items.plateNo = plateNo;
                commit(types.SET_PARAM, ['mapData', items]);
                resolve(response.data)

            } catch (err) {
                reject(err);
            }
        });
    }

}

const mutations = {
    [types.SET_PARAM](state, [key, value]) {
        Vue.set(state, key, value);
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}

export { TrackingType, NO_TRACK };



// WEBPACK FOOTER //
// ./src/store/modules/truck.js